import ActionType from '../action-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  unapprovedTransactions: null,
  page: 1,
  total: 0,
  perPage: 20,
  tranxView: 'normal',
  searchResult: null,
  searchResultLoading: false,
  searchResultError: null,
  filterResult: null,
  filterResultLoading: false,
  filterResultError: null,
  filterResultPage: 1,
  filterResultTotal: 0,
  filterResultPerPage: 20
};

// eslint-disable-next-line default-param-last
const unApprovedTransactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_UNAPPROVED_TRANSACTIONS_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        unapprovedTransactions: null,
        page: action.payload.page
      };
    case ActionType.FETCH_UNAPPROVED_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        unapprovedTransactions: action.payload.transactions,
        total: action.payload.total,
        page: action.payload.current_page,
        perPage: action.payload.per_page
      };
    case ActionType.FETCH_UNAPPROVED_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        unapprovedTransactions: null,
        page: 1,
        total: 0,
        perPage: 20
      };
    case ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_START:
      return {
        ...state,
        searchResultLoading: true,
        searchResultError: null,
        searchResult: null
      };
    case ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_SUCCESS:
      return {
        ...state,
        searchResultLoading: false,
        searchResultError: null,
        searchResult: action.payload
      };
    case ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_ERROR:
      return {
        ...state,
        searchResultLoading: false,
        searchResultError: action.payload,
        searchResult: null
      };
    case ActionType.FILTER_UNAPPROVED_TRANSACTIONS_START:
      return {
        ...state,
        filterResultLoading: true,
        filterResultError: null,
        filterResult: null
      };
    case ActionType.FILTER_UNAPPROVED_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        filterResultLoading: false,
        filterResultError: null,
        filterResult: action.payload.data,
        filterResultPage: action.payload.current_page,
        filterResultTotal: action.payload.total,
        filterResultPerPage: action.payload.per_page
      };
    case ActionType.FILTER_UNAPPROVED_TRANSACTIONS_ERROR:
      return {
        ...state,
        filterResultLoading: false,
        filterResultError: action.payload,
        filterResult: null,
        filterResultPage: 1,
        filterResultTotal: 0,
        filterResultPerPage: 20
      };
    case ActionType.SET_UNAPPROVED_TRANSACTIONS_VIEW:
      return {
        ...state,
        tranxView: action.payload
      };
    default:
      return state;
  }
};

export default unApprovedTransactionsReducer;
